document.addEventListener('DOMContentLoaded', function () {

  // サムネイルスライダー
  const thumbnailSwiper = new Swiper('.s-kv__slider__thumbnail', {
    slidesPerView: 1,
    watchSlidesProgress: true,
    allowTouchMove: false,
  });

  // メインスライダー
  const mainSwiper = new Swiper('.s-kv__slider', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    thumbs: {
      swiper: thumbnailSwiper,
    },
    pagination: {
      el: '.s-kv__slider__pagination',
      clickable: true,
    },
    on: {
      init: function () {
        const activeBullet = document.querySelector(
          '.s-kv__slider__pagination .swiper-pagination-bullet-active'
        );
        if (!activeBullet) return;

        activeBullet.classList.remove('swiper-pagination-bullet-active');

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            activeBullet.classList.add('swiper-pagination-bullet-active');
          });
        });
      },
      slideChangeTransitionStart: function () {
        // 全サムネイルのis-bounceを先に削除
        const allThumbs = document.querySelectorAll(
          '.s-kv__slider__thumbnail .swiper-slide'
        );
        allThumbs.forEach(function (thumb) {
          thumb.classList.remove('is-bounce');
        });

        const activeThumb = document.querySelector(
          '.s-kv__slider__thumbnail .swiper-slide-thumb-active'
        );
        if (!activeThumb) return;

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            activeThumb.classList.add('is-bounce');
          });
        });
      },
    },
  });

});